import { Link } from 'react-router-dom';
import Chip from '@mui/material/Chip';
import dayjs from 'dayjs';
import HelpIcon from '@mui/icons-material/Help';
import { IconButton } from '@mui/material';
import Model from '../models/model';
import strings from "../Globalization/index";
import consts from '../consts';
import util from '../util';

const { viewOnly } = util;
const attachmentRenderer = (params) => {
	const { TaskAssignmentId: associationId = 0, AttachmentCount: attachmentCount = 0, Help: help } = params.row;
	if (help || attachmentCount !== 0) {
		return <IconButton
			color="primary"
			component={Link}
			to={encodeURI(
				`/cycleattachmentlist?AssociationId=${associationId}&AttachmentTypeId=${consts.Task.AssociationType}&AssociationTypeId=${consts.Task.AttachmentType}&attachment=${strings.TaskAssignment}&isFromScreen=false&Help=${help}`
			)}
		>
			<HelpIcon fontSize="inherit" />
		</IconButton>
	}
	return <Link to={`cycleattachmentlist/${associationId}/${consts.Task.AssociationType}/${consts.Task.AttachmentType}/${strings.Task}/${true}/${help}`}><button disabled={true} className='btn btn-default blank-attchmentBtn'>N/A</button></Link>
}

const isReadOnly =
	(field) =>
		({ formik, activeRecord }) => {
			let isReadOnly = false;
			if (activeRecord.record.TaskStatusId === consts.TaskStatus.InComplete) {
				isReadOnly = true;
			}
			return isReadOnly;
		}

const statusFormat = ({ value, row, colDef }) => {
	const lookup = colDef.getCombos().TaskStatus;
	const { TaskStatusId, TaskStatus } = row;
	// Since we are showing the task status based on language, we need to get color based on TaskStatusId
	let status = lookup?.find((v) => v.LookupId === TaskStatusId);
	let backgroundColor = status?.CustomStringValue;
	return (
		<Chip size="small" sx={{ backgroundColor }} label={TaskStatus}>
			{TaskStatus}
		</Chip>
	);
}

export const model = new Model({
	name: 'Task',
	defaultSort: 'TaskName',
	readOnly: viewOnly,
	disableExport: viewOnly,
	disableAdd: true,
	disableDelete: true,
	formTitleField: 'TaskName',
	title: 'Task',
	gridRefreshInterval: 300000,
	showGridRefreshBtn: true,
	combos: [
		{ type: 'User', loaded: true },
		{ type: 'TaskStatus', loaded: true }
	],
	initialValues: {
		UserId: 0
	},
	customizeSaveData: (data, { activeRecord }) => {
		if (data.TaskStatusId === consts.TaskStatus.Complete && activeRecord?.record?.TaskStatusId !== consts.TaskStatus.Complete) {
			data.ExecutedOn = dayjs().format(consts.MomentFormat.DateTimeFormat);
		}
		return ({ ...data, UserId: data.UserId || 0 })
	},
	formGroups: [
		{
			fields: ['TaskStatusId', 'Notes', 'UserId']
		}
	],
	columns: [
		{ field: 'EquipmentName', formField: 'EquipmentId', width: 180, isNotformfield: true },
		{ field: 'TaskType', width: 200, isNotformfield: true },
		{ header: 'Task', field: 'TaskName', width: 150, isNotformfield: true },
		{ field: 'TaskDescription', width: 250, isNotformfield: true },
		{
			field: 'TaskStatus',
			header: 'TaskStatus',
			formField: 'TaskStatusId',
			width: 170,
			renderCell: statusFormat,
			lookup: 'TaskStatus',
			ignoreLookupOnGridFilter: true,
			required: true,
			readOnly: isReadOnly('TaskStatusId'),
			onChange: ({ formik }) => {
				if (formik.values.TaskStatusId === consts.TaskStatus.Complete && (!formik.values.ExecutedOn || !dayjs(formik.values?.ExecutedOn).isValid())) {
					formik.setFieldValue('ExecutedOn', dayjs())
				}
			}
		},
		{
			header: 'Assignee',
			field: 'AssignedToUser',
			formField: 'UserId',
			label: 'Users',
			lookup: 'User',
			ignoreLookupOnGridFilter: true,
			width: 150,
			required: [['TaskStatusId', () => consts.TaskStatus.ClosedNoAction]],
			inputWhen: [['TaskStatusId', () => consts.TaskStatus.ClosedNoAction]]
		},
		{
			header: 'ExpectedRun',
			field: 'ExpectedRunAt',
			width: 160,
			type: 'dateTime',
			ignoreMaxDate: true,
			isNotformfield: true
		},
		{
			header: 'ExpectedEnd',
			field: 'ExpectedEndAt',
			width: 160,
			type: 'dateTime',
			ignoreMaxDate: true,
			isNotformfield: true
		},
		{
			header: 'CompletedOn',
			field: 'ExecutedOn',
			width: 160,
			type: 'dateTime',
			ignoreMaxDate: true,
			isNotformfield: true
		},
		{ field: 'Help', width: 120, renderCell: attachmentRenderer, isNotformfield: true, filterable: false },
		{ header: 'User', field: 'Username', width: 120, isNotformfield: true },
		{ field: 'Notes', width: 250 },
		{
			field: 'startDate',
			header: 'StartDate',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			filterable: false,
			maxDate: ({ formik }) => (formik.values.endDate ? dayjs(formik.values.endDate) : undefined),
			hidden: true
		},
		{
			field: 'endDate',
			header: 'EndDate',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			minDate: ({ formik }) => (formik.values.startDate ? dayjs(formik.values.startDate) : undefined),
			hidden: true
		}
	],
	headerFilterProps: {
		className: 'HeaderFilterForm'
	}
});

export default model.createFormBase();
